const domain: string = 'ACCESSIBILITY'

export const SAVE_ACCESSIBILITY: string = `${domain}/SAVE_ACCESSIBILITY`
